export type TestimonialId =
  | 'el'
  | 'gje'
  | 'lwh'
  | 'keak'
  | 'kak'
  | 'ad'
  | 'hn'
  | 'fs'
  | 'ak'
  | 'fj'
  | 'na'
  | 'es'
  | 'pp'
  | 'nhr'
  | 'nit'

export type Testimonial = {
  id: TestimonialId
  name: string
  logo: string
  comment: string
  featured: boolean
}

export const testimonies: Testimonial[] = [
  {
    name: 'Evans Lam',
    logo: 'tvb',
    comment:
      'The upskilling and job placement experience at TalentLabs were some of the happiest moments in my life.',
    id: 'el',
    featured: true
  },
  {
    name: 'Goh Jia Ean',
    logo: 'nielsen',
    comment:
      'The course materials were comprehensive, yet easy to follow. And with the help of TalentLabs, I managed to secure a placement in Nielsen!',
    id: 'gje',
    featured: true
  },
  {
    name: 'Lee Wynn Hann',
    logo: 'cimb',
    comment:
      "TalentLabs's programme provided me with all the fundamental knowledge and skills that I needed to kick-start my career in tech.",
    id: 'lwh',
    featured: true
  },
  {
    name: 'Khairul Ezaidi Abu Khalib',
    logo: 'lenovo',
    comment:
      "This programme met all of my expectations. I'm grateful to the TalentLabs' team for helping me land a job in a reputable MNC.",
    id: 'keak',
    featured: true
  },
  {
    name: 'Khairunnisa Abu Khair',
    logo: '2x',
    comment:
      'For anyone new in tech, I recommend joining TalentLabs. They offer all the right coaching, modules and support you need to succeed!',
    id: 'kak',
    featured: false
  },
  {
    name: 'Afeeq Danial',
    logo: 'keysight',
    comment:
      'Even coming from a STEM background, I had limited experience in coding. TalentLabs helped fill that gap I needed to stand out.',
    id: 'ad',
    featured: false
  },
  {
    name: 'Hussain Nisaar',
    logo: 'l2',
    comment:
      'Opting for TalentLabs Data Analytics Certificate was one of the best decisions I have made, I was impressed with the curriculum design.',
    id: 'hn',
    featured: false
  },
  {
    name: 'Fuzeymi Sobri',
    logo: 'pos',
    comment:
      'This course is great for beginners like me. I would like to thank the Talentlabs team for providing excellent guidance throughout.',
    id: 'fs',
    featured: false
  },
  {
    name: 'Azam Khalid',
    logo: 'harigaji',
    comment:
      'With the help of my mentors at TalentLabs, classmates, and instructors, I was able to gain a globally recognised certificate!',
    id: 'ak',
    featured: false
  },
  {
    name: 'Firdaus Jamaludin',
    logo: 'recruitopia',
    comment:
      'The guidance from the experienced team of instructors boosted my confidence and skills as a developer.',
    id: 'fj',
    featured: false
  },
  {
    name: 'Noor Aisyah',
    logo: 'telus',
    comment:
      'Coming from a biochemistry background, I had limited knowledge in tech. This programme is invaluable in helping me venture into a new field.',
    id: 'na',
    featured: true
  },
  {
    name: 'Eiman Salleh',
    logo: 'proximax',
    comment:
      "The TalentLabs' career support and CV workshop are truly incredible for my overall career journey.",
    id: 'es',
    featured: true
  },
  {
    name: 'Nurin Husna Rushdi',
    logo: 'deloitte',
    comment: `I have acquired new knowledge and skills that not only enhance my personal growth, but also my professional development.`,
    id: 'nhr',
    featured: true
  },
  {
    name: 'Nur Iman Tan',
    logo: 'pwc',
    comment: `TalentLabs covered all the essentials for coding, and I'd sugest it for fellow grads looking to break into the tech world.`,
    id: 'nit',
    featured: true
  },
  {
    name: 'Priyesh Patel',
    logo: 'pwc',
    comment: `The chance to connect with top Malaysian companies for career opporutnities is fantastic!`,
    id: 'pp',
    featured: true
  }
]
